import PropTypes from 'prop-types'
import React from 'react'
import ReactTooltip from 'react-tooltip'
import styles from './_myCourseResults.css'
import { FormattedDistance } from 'shared/units'
import { FormattedElevation } from 'shared/units'
import { FormattedMessage, FormattedDate } from 'react-intl'
import Loader from 'components/util/Loader'
import { ACHIEVEMENTS } from './constants/messages'
import { CLIMB_ICONS } from './constants/climbIcons'

export default function MyCourseResults (props) {
  const {
    courses,
    loading,
  } = props

  return (
    <section className={styles.resultsContainer}>
      <table className={styles.tableContainer}>
        <thead>
          <tr>
            <th className={styles.achievementCell}>
              <FormattedMessage id='mycourses.table.achievements' defaultMessage='Achievements' />
            </th>
            <th><FormattedMessage id='mycourses.table.best' defaultMessage='Best Day' /></th>
            <th className={styles.climbCell}>
              <FormattedMessage id='mycourses.table.climb' defaultMessage='Climb' />
            </th>
            <th><FormattedMessage id='mycourses.table.dist' defaultMessage='Distance' /></th>
            <th><FormattedMessage id='mycourses.table.freq' defaultMessage='Frequency' /></th>
            <th><FormattedMessage id='mycourses.table.name' defaultMessage='Name' /></th>
            <th><FormattedMessage id='mycourses.table.elevation' defaultMessage='Elevation' /></th>
            <th className={styles.thumbnailCell}>
              <FormattedMessage id='mycourses.table.course' defaultMessage='Course' />
            </th>
          </tr>
        </thead>
        {courses && courses.length ?
          <tbody>
            {courses.map((course, i) => {
              let bestDay = '--'

              if (course.best_workout) {
                const courseBest = course.best_workout.date
                bestDay = <FormattedDate value={new Date(courseBest.year, courseBest.month, courseBest.day)} />
              }

              return (<tr key={i}>
                <td className={styles.achievementCell}>
                  {course.achievements.map((achievement, idx) => {
                    return (
                      <div key={idx}>
                        <img data-tip data-for={`achievement--${idx}`} src={achievement.icon_url} />
                        <ReactTooltip id={`achievement--${idx}`} place='top' type='dark' effect='solid'>
                          <div className={styles.achievementTitle}>
                            {ACHIEVEMENTS[achievement.achievement_type].title}
                          </div>
                          <div className={styles.achievementSummary}>
                            {ACHIEVEMENTS[achievement.achievement_type].description}
                          </div>
                        </ReactTooltip>
                      </div>
                    )
                  })}
                </td>
                <td>
                  <a href={`/courses/${course.id}`}>
                    {bestDay}
                  </a>
                </td>
                <td className={styles.climbCell}>
                  {course.climb_category !== null ?
                    <img src={CLIMB_ICONS[`climb${course.climb_category}`]} className={styles.climbIcon} />
                  : null}
                </td>
                <td><FormattedDistance value={course.distance} /></td>
                <td>{course.times_completed_by_user}</td>
                <td>
                  <a href={`/courses/${course.id}`}>
                    {course.name}
                  </a>
                </td>
                <td className={styles.elevationCell}><FormattedElevation value={course.elevation_diff} /></td>
                <td className={styles.thumbnailCell}>
                  <a href={`/courses/${course.id}`}>
                    <img src={course.thumbnail} className={styles.courseThumbnail} />
                  </a>
                </td>
              </tr>)
            })}
          </tbody> : null}
      </table>
      {!loading && courses && !courses.length ?
        <div>
          <FormattedMessage
            id='mycourses.notfound'
            defaultMessage='No Courses Found' />
        </div> : null}

      {loading ?
        <div className={styles.loadingOverlay}>
          <Loader type='spin' height={60} width={60} />
        </div> : null}
    </section>
  )
}

MyCourseResults.propTypes = {
  courses: PropTypes.array,
  loading: PropTypes.bool,
}
